import React from 'react'

const TRFIndicator = ({candidate}) => {
    if(candidate?.trf?.Status === false) {
        return <span style={{ color: "#f27474" }}>In Active</span>
    }

    if(candidate?.trf?.Status && candidate?.trf?.isTRFApproved === null){
        return <span style={{ color: "orange" }}>In Process</span>
    }

    if(candidate?.trf?.Status && candidate?.trf?.isTRFApproved){
        return <span style={{ color: "#52c41a" }}>Active</span>
    }   

    if(candidate?.trf?.Status && candidate?.trf?.isTRFApproved === false){
        return <span style={{ color: "#f27474" }}>Rejected</span>
    }

  return <></>
}

export default TRFIndicator
